import { FC } from 'react'
import { LoadingAnimation, Wrapper } from 'src/components'

const LoadingPage: FC = () => (
  <Wrapper title=" " entry=" ">
    <LoadingAnimation />
  </Wrapper>
)
export default LoadingPage
